<template>
  <div class="spruce-list" :style="{ width:width+'px' }">
    <a
      v-for="(item,index) in List"
      :key="index"
      :href="item.url"
      target="_blank"
      :style="{ borderColor:color }"
      class="spruce-item"
    >{{item.title}}</a>
  </div>
</template>

<script>
export default {
  name: "spruce-list",
  props: {
    List: Array,
    color: String,
    width: Number
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
.spruce-list {
  .spruce-item {
    display: block;
    height: 14px;
    line-height: 14px;
    color: rgba(17, 17, 17, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    padding-left: 10px;
    border-left: #111 solid 2px;
    color: #666;
    @include ellipsis();
    &:hover {
      color: #4272ab !important;
    }
  }
  .spruce-item + .spruce-item {
    margin: 20px 0;
  }
}
</style>

